import { isDingding } from '@liepin/js-core-h5/src/env';
import cookie from '@liepin/js-core-h5/src/cookie';

/**
 * User相关方法
 * @namespace User
 * @name User
 * @static
 */
const User = {};
User.get = function () {
  let uniqueKey = cookie.get('UniqueKey');
  uniqueKey = /^["']*$/.test(uniqueKey) ? null : uniqueKey;
  /**
   * 判断当前用户是否登录
   * @name User.isLogin
   * @property isLogin
   *
   * @return {Boolean} 用户登录状态
   */
  this.isLogin = !!uniqueKey;
  /**
   * 当前登录用户ID
   * @name User.userId
   * @property userId
   *
   * @return {Boolean} 当前登录用户ID
   */
  this.userId = uniqueKey;
  /**
   * 用户是否登录过猎聘
   * @name User.isLPUser
   * @property isLPUser
   *
   * @return {Boolean} 用户是否登录过猎聘
   */
  this.isLPUser = cookie.get('is_lp_user');
  /**
   * 当前登录用户姓名
   * @name User.userName
   * @property userName
   *
   * @return {Boolean} 当前登录用户姓名
   */
  this.userName = cookie.get('user_name');
  /**
   * 当前登录用户类型
   * @name User.userKind
   * @property userKind
   *
   * @return {Boolean} 当前登录用户类型
   */
  this.userKind = cookie.get('user_kind');
  /**
   * 当前登录用户头像
   * @name User.userPhoto
   * @property userPhoto
   *
   * @return {Boolean} 当前登录用户头像
   */
  this.userPhoto = cookie.get('user_photo') || '55557f3b28ee44a8919620ce01a.gif';

  /**
   * 是否需要登录, 未登录跳转登录页
   * @param {*} url 回跳url
   * @param {*} skip 是否跳过完简 true不走完简, false走完简
   */
  this.needLogin = (url, skip) => {
    this.get();
    if (this.isLogin) {
      return false;
    }
    const improveInfoPrama = skip ? '' : '&improveInfo=1';
    const encodeUrl = encodeURIComponent(url || window.location.href);
    if (isDingding) {
      window.location.href = `dingtalk://dingtalkclient/action/open_mini_app?miniAppId=2021001186691967&page=${
        encodeURIComponent(`/pages/login/index?nonstop=1${improveInfoPrama}&backUrl=${
          encodeURIComponent(`/pages/webview/index?login=1&url=${encodeUrl}`)
        }`)
      }`;
    } else {
      window.location.href = `/register/?return_url=${encodeUrl}${skip ? '&nonstop=1' : ''}`;
    }
    return true;
  };
  const userRoles = cookie.get('user_roles');
  this.isC = this.isLogin && userRoles && userRoles.includes('0');
  this.isB = this.isLogin && userRoles && userRoles.includes('1');
  this.isH = this.isLogin && userRoles && userRoles.includes('2');
};
User.get(); // 初始化User

export default User;
